export default __webpack_public_path__ + "static/media/ddl-search.7235e0b6.svg";